import React from "react";
import PropTypes from "prop-types";
import { LoadingIndicator } from "@sainsburys-tech/fable";

const LoadingWrapper = props => {
  if (props.isLoading)
    return <LoadingIndicator isLoading shouldPreventFocus isStandalone size="lg"/>;

  return props.children;
};

LoadingWrapper.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.object.isRequired
};

export default LoadingWrapper;
